export type TStepStatus = 'complete' | 'current' | 'incomplete'

export type TMenuStep = {
  key: string
  order: number
}

export type TMenuStepWithStatus = TMenuStep & {
  status: TStepStatus
}

export const FOUNDING_STEP_INDEX = 1
export const PRACTICE_BUILDER_ROLES = ['Practice Builder']

const KEY_INITIATIVES_STEPS_KEY = 'jbp-key-initiatives-steps'
export const KEY_INITIATIVES_STEP_LABEL_SUFFIX = '-label'
export const KEY_INITIATIVES_STEP_DESC_SUFFIX = '-desc'
export const KEY_INITIATIVES_STEPS: TMenuStep[] = [
  {
    key: `${KEY_INITIATIVES_STEPS_KEY}-initiative`,
    order: 0,
  },
  {
    key: `${KEY_INITIATIVES_STEPS_KEY}-founding`,
    order: 1,
  },
  {
    key: `${KEY_INITIATIVES_STEPS_KEY}-goal`,
    order: 2,
  },
  {
    key: `${KEY_INITIATIVES_STEPS_KEY}-status`,
    order: 3,
  },
]
